import React, { createContext, useContext, useEffect, useState } from 'react';
import LoadingOverlay from '../components/LoadingOverlay';
import { subscribeApiLoading } from '../utils/apiLoadingBus';

const ApiLoadingContext = createContext({ pendingCount: 0 });

export function ApiLoadingProvider({ children, message = 'Please wait…' }) {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => subscribeApiLoading(setPendingCount), []);

  return (
    <ApiLoadingContext.Provider value={{ pendingCount }}>
      {children}
      <LoadingOverlay show={pendingCount > 0} message={message} />
    </ApiLoadingContext.Provider>
  );
}

export function useApiLoading() {
  return useContext(ApiLoadingContext);
}
